import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';
import { RequiredValidatorData } from '../../data-type/required';

@Component({
  selector: 'df-required-validator-editor',
  templateUrl: './required-validator-editor.component.html',
  styleUrls: ['./required-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequiredValidatorEditorComponent extends ValidatorEditorBase<RequiredValidatorData> implements OnInit {
  get showAtView(): boolean {
    return this.data.showAtView;
  }
  set showAtView(show: boolean) {
    this.data.showAtView = show;
    this.emitModelChange();
  }

  ngOnInit() {
    if (!this.caption) {
      this.caption = 'å¿å¡«';
    }
  }

  defaultModelData(): RequiredValidatorData {
    return {} as RequiredValidatorData;
  }
}
